 
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let StringUtils;
export default (StringUtils = (function() {
  let BLANK_STRING_REGEX;
  StringUtils = class StringUtils {
    static initClass() {
      BLANK_STRING_REGEX = /^\s*$/;
    }

    static capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    static isBlank(str) {
      return !str || BLANK_STRING_REGEX.test(str);
    }

    // HTML encode contents of a string, optionally preserving some nodes (ex: ["br","var"])
    static escapeHTML(str, preserveNodes) {
      let index;
      let part;
      let fullParts = [{ escaped: false, val: str }]; // Initial format, full unescaped string

      if (preserveNodes) {
        // Iteratively break the string into array of parts in format {escaped:boolean, val:str} based on supplied nodes
        // to preserve

        const matchSplit = function(re, str) {
          // Split a string with a regexp (with assumed match capture group) and mark each part appropriately as escped
          // or not, depending on if it's from the capture group
          const parts = str.split(re);
          for (let index = 0; index < parts.length; index++) {
            const part = parts[index];
            parts[index] = {
              escaped: index % 2 !== 0,
              val: part
            };
          }
          return parts;
        };

        // For each node to preserve, tokenize and split on that node, marking node as escaped
        for (const node of Array.from(preserveNodes)) {
          // Regexp looks for node, including permutations of start/stop tag, included attributes, and self-closing tags
          const nodeTagMatcher = new RegExp(`(<\/?${node}[^>]*\/?>)`, 'gi');

          // Iterate backwards through fullParts, escaping what needs escaping via tokenization
          for (index of Array.from(_.range(fullParts.length - 1, -1, -1))) {
            part = fullParts[index];
            if (!part.escaped) {
              const newParts = matchSplit(nodeTagMatcher, part.val);
              // Rebuild fullParts, replacing part with expanded newParts
              fullParts = fullParts
                .slice(0, index)
                .concat(newParts)
                .concat(fullParts.slice(index + 1));
            }
          }
        }
      }

      // Finally, for any parts marked as not escaped, HTML encode to text
      for (index = 0; index < fullParts.length; index++) {
        part = fullParts[index];
        if (!part.escaped) {
          const div = document.createElement('div');
          div.appendChild(document.createTextNode(part.val));
          fullParts[index].val = div.innerHTML;
        }
      }

      // Combine parts into just their values and return
      return fullParts.map(part => part.val).join('');
    }
  };
  StringUtils.initClass();
  return StringUtils;
})());
